// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6f03aa65","455":"34c9c166","977":"bd823bd4"}[chunkId] + ".chunk.js";
};